import {
    copropSvr
} from '../_services';

const actions = {
    acBuscarUsuarioPorDni({
        commit
    }, dni) {
        return new Promise((resolve, reject) => {
            
            copropSvr.acBuscarUsuarioPorDni(dni).then(res => {
                return resolve(res.data);
            }).catch(error => {
                return reject(error);
            })

        });
    }
}

export const coprop = {
    namespaced: true,
    actions
}